import { render } from "./DataServiceOffersShowView.vue?vue&type=template&id=ec78f9c0"
import script from "./DataServiceOffersShowView.vue?vue&type=script&lang=js"
export * from "./DataServiceOffersShowView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__